import * as yup from 'yup';

export const PaypalInfoSchema = yup.object().shape({
  email: yup
    .string()
    .required({ tx: 'errors.required' })
    .email({ tx: 'errors.email' }),
  name: yup.string().required({ tx: 'errors.required' }),
});
